import React from 'react';

export const HighlightWords = ({
  className,
  phrase,
  highlights = [],
}: {
  className: string;
  phrase: string | undefined;
  highlights?: string[];
}) => {
  if (!phrase) {
    return <></>;
  }

  const pieces = phrase.split('%param');
  return (
    <p className={`highlight-word ${className}`}>
      {pieces.map((piece, i) => (
        <React.Fragment key={piece}>
          {piece}
          {highlights && highlights[i] && <strong>{highlights[i]}</strong>}
        </React.Fragment>
      ))}
    </p>
  );
};
